import * as React from 'react'
import { Input as InputPrimitive } from '@base-ui/react/input'

import { cn } from '@repo/ui/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'

const inputVariants = cva(
  cn(
    'h-8 w-full min-w-0 rounded-md px-2.5 py-1 text-base transition-colors outline-none selection:bg-primary selection:text-primary-foreground md:text-sm',
    'placeholder:text-muted-foreground',
    'file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
    'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:disabled:bg-input/80',
    'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
    'transition-all',
  ),
  {
    defaultVariants: {
      variant: 'default',
    },
    variants: {
      variant: {
        default: cn(
          'border border-input bg-transparent shadow-xs dark:bg-input/30',
          'focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50',
        ),
        ghost: cn(
          'border border-transparent bg-transparent shadow-none',
          'hover:bg-accent dark:hover:bg-accent/50',
          'focus-visible:bg-accent dark:focus-visible:bg-accent/50',
        ),
      },
    },
  },
)

function Input({
  className,
  type,
  variant,
  ...props
}: React.ComponentProps<'input'> & VariantProps<typeof inputVariants>) {
  return (
    <InputPrimitive
      className={cn(inputVariants({ variant }), className)}
      data-slot="input"
      type={type}
      {...props}
    data-sentry-element="InputPrimitive" data-sentry-component="Input" data-sentry-source-file="input.tsx" />
  )
}

export { Input }
